import Home from './pages/Home';

const routes = [
  {
    path: '/',
    component: Home,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/App/routes.js